// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"51517be6","484":"14cb0921","551":"8912905c"}[chunkId] + ".chunk.js";
};